module.exports = __webpack_public_path__ + "img/1_006.2f14c336.jpg";